<template>

    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item class="query-form-item">
                <el-input v-model="query.username" placeholder="用户名"></el-input>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-select v-model="query.status" placeholder="状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="禁用" value="0"></el-option>
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="未验证" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-select v-model="query.role_id" placeholder="角色">
                    <el-option label="全部角色" value=""></el-option>
                    <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="getList"></el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="search" @click="onSubmit">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click.native="handleForm(null,null)">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            style="width: 100%;"
            max-height="500">
            <el-table-column
                label="用户 ID"
                prop="id"
                fixed>
            </el-table-column>
            <el-table-column
                label="用户名"
                prop="username"
                fixed>
            </el-table-column>
            <el-table-column
                label="状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status | statusFilterType">{{scope.row.status | statusFilterName}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                label="登录时间"
                with="300"
                :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    <span>{{ scope.row.last_login_time | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="登录IP">
                <template slot-scope="scope">
                    <span>{{ scope.row.last_login_ip }}</span>
                </template>
            </el-table-column>


            <el-table-column
                label="备注"
                prop="remark"
                fixed>
            </el-table-column>

            <el-table-column
                label="操作"
                fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click.native="handleForm(scope.$index, scope.row)">编辑
                    </el-button>
                    <el-button type="text" size="small" @click.native="handleDel(scope.$index, scope.row)">删除
                    </el-button>
                    <el-button type="text" size="small" @click.native="check(scope.row)">查看策略
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            :page-size="query.limit"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :total="total">
        </el-pagination>

        <!--表单-->
        <el-dialog
            :title="formMap[formName]"
            :visible.sync="formVisible"
            :before-close="hideForm"
            width="85%"
            top="5vh">
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="用户名" prop="username">
                    <el-input v-model="formData.username" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="登录密码" prop="password">
                    <el-input type="password" v-model="formData.password" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPassword">
                    <el-input type="password" v-model="formData.checkPassword" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="formData.remark" ></el-input>
                </el-form-item>
                
                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="formData.status">
                        <el-radio label="0">禁用</el-radio>
                        <el-radio label="1">正常</el-radio>
                        <el-radio label="2">未验证</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="角色">
                    <el-checkbox-group v-model="formData.roles">
                        <el-checkbox v-for="item in roles" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="到期时间">
                    <el-date-picker
                              v-model="formData.times"
                              type="date"
                              
                              value-format="timestamp"
                              dateType="time"
                              placeholder="选择日期">
                            </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">提交</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="opencheck" width="1000px" append-to-body>
           <el-table :data="tableData" v-loading="loading" style="width: 100%">
            <el-table-column prop="site_id" align='center' label="ID" width="60">
            </el-table-column>
            
            <!-- <el-table-column label="屏蔽vpn" align='center' width="120">
                <template slot-scope="scope">
                    {{scope.row.delivery?'是':'否'}}
                </template>
            </el-table-column> -->
            <el-table-column prop="name" align='center' label="策略名称" >
            </el-table-column>
            <el-table-column prop="region" align='center' label="国家" >
            </el-table-column>
            <el-table-column prop="type" align='center' label="可见设备">
            </el-table-column>
            <el-table-column prop="youdao" align='center' label="安全页">
            </el-table-column>
            <el-table-column prop="youdaolianjie" align='center' label="安全页链接">
            </el-table-column>
            <el-table-column prop="anquan" align='center' label="落地页">
            </el-table-column>
            <el-table-column prop="anquanlianjie" align='center' label="落地页链接">
            </el-table-column>
            <el-table-column align='center' width="300" label="操作">
                <template slot-scope="scope">
                    <el-button type="success" plain size="mini" @click="handleUpdate(scope.row)">查看</el-button>
                    
                </template>
            </el-table-column>
        </el-table>
        </el-dialog>

        <el-dialog :visible.sync="openpdf" width="1000px" append-to-body>
            <el-form :model="form" :rules="formRules" label-width="80px" ref="dataForm">
                <!-- <el-form-item label="广告域名">
    <el-input v-model="form.name"></el-input>
  </el-form-item> -->
   <el-row>
                    <el-col :span="12">
                        <el-form-item label="安全模式" prop="delivery">
                    <el-switch v-model="form.moshi"></el-switch>
       
                </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="策略名称" prop="name">
                        <el-input
                        v-model="form.name">
                            </el-input>
                        </el-form-item>
                    </el-col>
   </el-row>
                
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="屏蔽爬虫">
                            <el-radio-group v-model="form.resource">
                                <el-radio label="是"></el-radio>
                                <el-radio label="否"></el-radio>
                            </el-radio-group>
                        </el-form-item>

                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="选择国家" prop="region">
                            <el-select v-model="form.region" multiple filterable placeholder="请选择">
                                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                 
                        </el-form-item>
                    </el-col>
                    
                    
                </el-row>

                <el-row>
                    
                    <el-col :span="12">
                        <!-- <el-form-item label="屏蔽VPN" prop="delivery">
                            <el-switch v-model="form.delivery"></el-switch>
                        </el-form-item> -->
                        <el-form-item  label="屏蔽无头浏览器" label-width="115px">
                          <el-switch v-model="form.heard"></el-switch>
                   
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="屏蔽浏览器语言" label-width="120px">
                            <el-select v-model="form.language" multiple filterable placeholder="请选择">
                                <el-option v-for="item in optionslanguage" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </el-col>
                </el-row>
                <el-row>
                   <el-col :span="12">
                        <el-form-item label="可见设备" prop="type">
                            <el-checkbox-group v-model="form.type">
                                <el-checkbox label="手机" name="type"></el-checkbox>
                                <el-checkbox label="电脑" name="type"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="屏蔽操作系统" label-width="105px">
                            <el-select v-model="form.opersystem" multiple filterable placeholder="请选择">
                                <el-option v-for="item in optionopersystem" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </el-col>
                </el-row>
                <el-row>
                   <el-col :span="12">
                        <el-form-item label="最大访问次数" prop="frequency" label-width="105px">
                            <el-input
                                 v-model.number='form.frequency'
                                 type='number'
                                >
                            </el-input>
                     
                           
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item  label="屏蔽不常见ISP" label-width="110px">
                          <el-switch v-model="form.isp"></el-switch>
                        </el-form-item>

                    </el-col>
                </el-row>
                 <el-row>
                   <el-col :span="12">
                        <el-form-item label="屏幕分辨率" prop="sceen" label-width="95px">
                           <el-switch v-model="form.sceen"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        

                    </el-col>
                </el-row>
                  <el-row v-if="form.sceen">
                   <el-col :span="6">
                        <el-form-item label="宽度>" prop="widths">
                            <el-input v-model.number='form.widths' type='number' >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item  label="高度>" prop="heights">
                         <el-input v-model.number='form.heights' type='number' >
                         </el-input>
                        </el-form-item>
             
                    </el-col>
                </el-row>
                 <el-row>
                    <el-col :span="12">
                        <el-form-item label="屏蔽非facebook来源流量" label-width="180px">
                            <el-radio-group v-model="form.refefef">
                                <el-radio label="是"></el-radio>
                                <el-radio label="否"></el-radio>
                            </el-radio-group>
                    
                        </el-form-item>

                    </el-col>
                 </el-row>
                <el-row class="anquan">
                    <el-col :span="12">
                        <p>安全页</p>
                        <el-form-item label="展示方式" prop="youdao">
                            <el-select v-model="form.youdao" placeholder="请选择">
                                <el-option v-for="item in youdaooptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        
                    

                        <el-form-item label="链接" prop="youdaolianjie" 
                        v-if="form.youdao=='301'||form.youdao=='采集'||form.youdao=='ifame'">
                            <el-input v-model="form.youdaolianjie"></el-input>
                        </el-form-item>

                        <el-form-item label="类型" prop="sitetype" 
                        v-if="form.youdao=='超简页'">
                            <el-select v-model="form.sitetype" placeholder="请选择">
                                <el-option v-for="item in sitetypeoptions" :key="item.name" :label="item.znname" :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        
                        <!-- <el-form-item label="类型" prop="complete" 
                        v-if="form.youdao=='整站'">
                            <el-select v-model="form.complete" placeholder="请选择">
                                <el-option v-for="item in completeoptions" :key="item.name" :label="item.znname" :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item> -->

                        <el-form-item label="商品类型" prop="commerce" 
                        v-if="form.sitetype=='commerce'&&form.youdao=='超简页'">
                            <el-select v-model="form.commerce" placeholder="请选择">
                                <el-option v-for="item in commerceoptions" :key="item.name" :label="item.znname" :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        
                         <!-- <el-form-item label="类型" prop="sitetype" 
                        v-if="form.youdao=='301'||form.youdao=='采集'||form.youdao=='ifame'">
                            <el-input v-model="form.youdaolianjie"></el-input>
                        </el-form-item> -->
                        <span style="color:#52bb4c;margin-right:20px" v-if="form.youdao=='inner html'">inner html方式只适用于php集成方式，js不适用</span>
                         
                         <span style="color:red;margin-left: 80px;" v-if="form.youdao=='301'">慎用</span>
                       
                    </el-col>
                    <el-col :span="12">
                        <p>落地页</p>
                        <el-form-item label="展示方式" prop="anquan">
                            <el-select v-model="form.anquan" placeholder="请选择">
                                <el-option v-for="item in anquanoptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="链接" prop="anquanlianjie"
                        v-if="form.anquan=='301'||form.anquan=='ifame'">
                            <el-input v-model="form.anquanlianjie"></el-input>
                           
                        </el-form-item>
                        <span style="color:#52bb4c" v-if="form.anquan=='inner html'">inner html方式只适用于php集成方式，js不适用</span>
                        <span style="color:#52bb4c" v-if="form.anquan=='原站点'">原站点方式只适用于js集成方式，php不适用</span>
                  
                    </el-col>
                </el-row>
                <!-- <el-form-item label="特殊资源">
    <el-radio-group v-model="form.resource">
      <el-radio label="线上品牌商赞助"></el-radio>
      <el-radio label="线下场地免费"></el-radio>
    </el-radio-group>
  </el-form-item> -->
             
            </el-form>
        </el-dialog>
    </div>

</template>

<script>
import {
    authAdminList,
    authAdminSave,
    authAdminDelete
} from "../../../api/auth/authAdmin";
import {
    adSiteList,   
} from "../../../api/ad/adSite";
const formJson = {
    id: "",
    password: "",
    username: "",
    checkPassword: "",
    status: "1",
    roles: [],
    times:'',
    remark:''
};
export default {
    data() {
        let validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.formData.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            form:{},
            openpdf:false,
            opencheck:false,
            tableData:[],
            roles: [],
            query: {
                username: "",
                status: "",
                page: 1,
                limit: 20,
                role_id: ""
            },
            list: [],
            total: 0,
            loading: true,
            index: null,
            formName: null,
            formMap: {
                add: "新增",
                edit: "编辑"
            },
            formLoading: false,
            formVisible: false,
            formData: formJson,
            formRules: {},
            addRules: {
                username: [
                    { required: true, message: "请输入姓名", trigger: "blur" }
                ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                    { validator: validatePass, trigger: "blur" }
                ],
                checkPassword: [
                    {
                        required: true,
                        message: "请再次输入密码",
                        trigger: "blur"
                    },
                    { validator: validatePass2, trigger: "blur" }
                ],
                status: [
                    { required: true, message: "请选择状态", trigger: "change" }
                ]
            },
            editRules: {
                username: [
                    { required: true, message: "请输入姓名", trigger: "blur" }
                ],
                status: [
                    { required: true, message: "请选择状态", trigger: "change" }
                ]
            },
            deleteLoading: false
        };
    },
    methods: {
        handleUpdate(row){
          console.log(row)
            let row1 = JSON.parse(JSON.stringify(row))

            console.log(row)

            row1.region = row1.region.split(",")
            row1.language = row1.language ? row1.language.split(",") : []
            row1.opersystem = row1.opersystem ? row1.opersystem.split(",") : []
            

            row1.type = row1.type.split(",")
            console.log(row1)
            if (row1.delivery) {
                row1.delivery = true
            }
            else {
                row1.delivery = false
            }
            if (row1.moshi) {
                row1.moshi = true
            }
            else {
                row1.moshi = false
            }

            if (row1.heard) {
                row1.heard = true
            }
            else {
                row1.heard = false
            }

              if (row1.isp) {
                row1.isp = true
            }
            else {
                row1.isp = false
            }
             if (row1.sceen) {
                row1.sceen = true
            }
            else {
                row1.sceen = false
            }

            
  

            this.form = row1
            this.openpdf = true
        },
         getcheckList(username) {
             let a={
                 'username':username,
             }
         
            adSiteList(a)
                .then(response => {
                    
                  
                    this.tableData = response.data

                })
        },
        check(row){
            console.log(row)
          this.opencheck=true
          this.getcheckList(row.username)
        },
        onSubmit() {
            this.$router.push({
                path: "",
                query: this.query
            });
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        getList() {
            this.loading = true;
            authAdminList(this.query)
                .then(response => {
                    this.loading = false;
                    this.list = response.admin_list.data || [];
                    this.total = response.admin_list.total || 0;
                    this.roles = response.role_list || [];
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                    this.roles = [];
                });
        },
        // 隐藏表单
        hideForm() {
            // 更改值
            this.formVisible = !this.formVisible;
            // 清空表单
            this.$refs["dataForm"].resetFields();
            return true;
        },
        // 显示表单
        handleForm(index, row) {
          
            this.formVisible = true;
            this.formData = Object.assign({}, formJson);
            if (row !== null) {
                this.formData = Object.assign({}, row);
                this.formData.times=this.formData.times*1000
            }
            this.formData.status += ""; // 转为字符串（解决默认选中的时候字符串和数字不能比较的问题）
            this.formName = "add";
            this.formRules = this.addRules;
            if (index !== null) {
                this.index = index;
                this.formName = "edit";
                this.formRules = this.editRules;
            }
            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
        },

        formSubmit() {
            
       
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    let data = Object.assign({}, this.formData);
                    data.times= data.times/1000
                    authAdminSave(data, this.formName).then(response => {
                        this.formLoading = false;
                        if (response.code) {
                            this.$message({
                                message: response.message,
                                type: "error"
                            });
                        } else {
                            this.$message({
                                message: "操作成功",
                                type: "success"
                            });
                            // 向头部添加数据
                            // this.list.unshift(res)
                            // 刷新表单
                            this.$refs["dataForm"].resetFields();
                            this.formVisible = false;
                            if (this.formName === "add") {
                                // 向头部添加数据
                                let resData = response || {};
                                this.list.unshift(resData);
                            } else {
                                this.list.splice(this.index, 1, data);
                            }
                        }
                    });
                }
            });
        },
        // 删除
        handleDel(index, row) {
            if (row.id) {
                
                        let para = { id: row.id };
                        authAdminDelete(para)
                            .then(response => {
                                this.deleteLoading = false;
                                if (response.code) {
                                    this.$message({
                                        message: response.message,
                                        type: "error"
                                    });
                                } else {
                                    this.$message({
                                        message: "删除成功",
                                        type: "success"
                                    });
                                    // 刷新数据
                                    this.list.splice(index, 1);
                                }
                            })
                   
            }
        }
    },
    filters: {
        statusFilterType(status) {
            const statusMap = {
                0: "gray",
                1: "success",
                2: "danger"
            };
            return statusMap[status];
        },
        statusFilterName(status) {
            const statusMap = {
                0: "禁用",
                1: "正常",
                2: "未验证"
            };
            return statusMap[status];
        }
    },
    mounted() {},
    created() {
        // 将参数拷贝进查询对象
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.limit = parseInt(this.query.limit);
        // 加载表格数据
        this.getList();
    }
};
</script>

<style scoped lang="scss">
.shuo{
    position: absolute;
    top: 40px;
    left: 0;
    color: #e6a23c;
}
.shuo1{
    position: absolute;
    top: 90px;
    right: 40px;
    color: #e6a23c;
}
.copy-code-button {
    margin: 0 auto;
}
.main {
    padding: 20px;
}
.anquan {
    border-top: 1px solid #d8dce5;
    p {
        text-align: center;
        margin: 10px 0 10px 0;
    }
}
.rowbutton {
    padding-bottom: 20px;
}
.el-select {
    width: 100%;
}
.el-row {
    margin-bottom: 10px;
}
//  v-deep .el-input .el-input__inner{
//   height: 28px !important;
//   line-height: 28px !important;
// }
</style>
